export const BenefitsGrayCard = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="30"
		height="30"
		viewBox="0 0 37.486 29.989"
	>
		<path
			id="credit_card_24dp_FILL0_wght400_GRAD0_opsz24"
			d="M117.486-796.251v22.492a3.61,3.61,0,0,1-1.1,2.647,3.61,3.61,0,0,1-2.647,1.1H83.749a3.61,3.61,0,0,1-2.647-1.1A3.61,3.61,0,0,1,80-773.76v-22.492a3.61,3.61,0,0,1,1.1-2.647,3.61,3.61,0,0,1,2.647-1.1h29.989a3.61,3.61,0,0,1,2.647,1.1A3.61,3.61,0,0,1,117.486-796.251ZM83.749-792.5h29.989v-3.749H83.749Zm0,7.5v11.246h29.989v-11.246Zm0,11.246v0Z"
			transform="translate(-80 800)"
			fill="#2C2C2C"
		/>
	</svg>
);
